var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGsma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 301",
    width: 100,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    d: "M438.73,133.47v33.76c0,41.2-9.86,67.11-30.39,87.54c-27.6,27.46-79.19,46.02-179.16,46.02 c-115.99,0-164.29-23.78-191.56-51C13.8,226.08,0,192.81,0,150.39c0-40.13,12.49-74.71,37.62-99.72C64.81,23.62,119.27,0,229.92,0 c87.89,0,153.2,14.55,188.36,30.9v60.16C376.55,69.8,309.77,53.62,229.59,53.62c-78.94,0-120.59,14.06-138.9,32.28 c-15.03,14.96-22.75,35.72-22.75,64.49c0,30.24,8.3,50.43,22.43,64.57c18.73,18.63,54.38,33.76,138.82,33.76 c67.28,0,111.22-11.03,128.06-27.79c10.93-10.87,14.21-22.72,14.13-35.47H194.6v-51.98L438.73,133.47L438.73,133.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    d: "M505.9,34.72C527.05,13.67,568.69,0,670.28,0C749.9,0,813.6,11.6,852.33,26.93v57.01 C808.19,65.3,734.16,51.62,670.45,51.62c-77.7,0-102.1,6.79-111.59,16.24c-4.66,4.64-6.75,10.77-6.75,18.15c0,7.13,2,12.93,6,16.9 c8.74,8.7,30.98,13.17,122.08,17.15c120.58,5.47,157.56,14.67,178.21,35.22c11.74,11.68,18.07,29.83,18.07,50.55 c0,21.71-4.58,41.93-20.49,57.75c-20.99,20.88-63.46,37.21-173.3,37.21c-81.28,0-160.64-12.84-205.53-32.15v-57.01 c43.22,20.38,135.49,37.54,205.53,37.54c77.86,0,107.67-5.72,119.42-17.4c5.5-5.47,7.33-12.01,7.33-18.89 c0-8.04-1.92-14.09-6.58-18.73c-8.66-8.62-24.57-12.51-126.91-17.4c-114.25-5.22-153.06-14.91-173.96-35.71 c-11.58-11.52-16.9-28.09-16.9-48.89C485.08,70.85,489.58,50.96,505.9,34.72z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BEBEBE",
    points: "1322.85,7.36 1166.59,252.4 1010.49,7.36 923.29,7.36 923.29,293.43 989.42,293.43 989.42,85.68 1120.09,293.43 1210.45,293.43 1340.83,86.68 1341.05,293.43 1408.16,293.43 1408.16,7.36  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    d: "M1582.64,176.79h179.98L1672.5,45.45L1582.64,176.79z M1719.24,7.36L1920,293.43h-77.34l-44.06-64.24h-251.86l-44.04,64.24 h-74.25L1629.21,7.36H1719.24z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    d: "M1846.95,50.24h-7.61V14.29h-13.62V7.3h34.84v6.99h-13.62v35.95H1846.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    d: "M1886.9,39.69h-0.24l-13.43-20.12v30.67h-7.42V7.3h8.04l13.07,20.3l13.07-20.3h8.04v42.94h-7.54V19.45L1886.9,39.69z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGsma);
export default __webpack_public_path__ + "static/media/GSMA.46914be5a2539952145cd8bef1d89182.svg";
export { ForwardRef as ReactComponent };